import { defineComponent, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'NewsList',
    props: {
        items: {
            default: () => [],
            type: Array,
        },
        title: {
            default: '',
            type: String,
        },
        theme: {
            default: 'dark',
            type: String,
            validator(value) {
                return ['light', 'dark'].includes(value);
            },
        },
        withBorderRadius: {
            default: false,
            type: Boolean,
        },
    },
    setup() {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        return {
            css,
        };
    },
});
